import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import admin, { adminActions, adminSelectors } from './admin';
import user, { userActions, userEpics, userSelectors } from './user';

// workaround to combineReducers typing issue:
// https://github.com/reduxjs/redux/issues/2709
export default combineReducers({
  admin,
  user,
});

export const rootEpic = combineEpics(userEpics);

// Aggregate list of actions
export const actions = {
  adminActions,
  userActions,
};

// Aggregate list of selectors
export const selectors = {
  adminSelectors,
  userSelectors,
};
